<template>
  <my-giving-layout :enable-scroll-event="true">
    <div class="p-[16px] min-h-screen flex flex-col justify-center items-center text-center">
      <!-- Success Icon -->
      <div class="mb-[40px]">
        <svg
          class="w-[120px] h-[120px] text-gray-600"
          fill="none"
          viewBox="0 0 120 120"
          xmlns="http://www.w3.org/2000/svg"
        >
          <!-- Car body -->
          <path
            d="M20 65 L35 45 L85 45 L100 65 L100 85 L20 85 Z"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
          />
          <!-- Wheels -->
          <circle cx="35" cy="85" r="8" stroke="currentColor" stroke-width="2" fill="none" />
          <circle cx="85" cy="85" r="8" stroke="currentColor" stroke-width="2" fill="none" />
          <!-- Windows -->
          <path
            d="M38 45 L38 62 L82 62 L82 45"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
          />
          <!-- Motion lines -->
          <path
            d="M10 35 L25 35 M5 40 L20 40 M8 30 L23 30"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
          <!-- Hand with document -->
          <g transform="translate(75, 25)">
            <!-- Document -->
            <rect
              x="0"
              y="5"
              width="20"
              height="25"
              rx="2"
              stroke="currentColor"
              stroke-width="2"
              fill="#FEC629"
            />
            <path
              d="M4 12 L16 12 M4 16 L16 16 M4 20 L12 20"
              stroke="currentColor"
              stroke-width="1"
            />
            <!-- Hand -->
            <path d="M8 30 Q12 28 15 30 Q18 32 15 35 Q12 38 8 35 Q5 32 8 30" fill="currentColor" />
            <!-- Motion lines -->
            <path
              d="M25 8 L30 6 M26 12 L31 10 M25 16 L30 14"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </g>
          <!-- Dashed road line -->
          <path
            d="M15 95 L25 95 M35 95 L45 95 M55 95 L65 95 M75 95 L85 95 M95 95 L105 95"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-dasharray="5,5"
          />
        </svg>
      </div>

      <!-- Main Title -->
      <h1 class="text-[2rem] font-[700] text-gray-900 leading-[2.5rem] mb-[24px] max-w-[280px]">
        Your application's on the way
      </h1>

      <!-- Description -->
      <p class="text-[1rem] text-gray-600 leading-[1.5rem] mb-[4px]">
        Your bank is processing it now. Check
      </p>

      <!-- Manage My Giving text -->
      <p class="text-[1rem] text-gray-900 font-[600] mb-[4px]">Manage My Giving</p>

      <!-- Additional info -->
      <p class="text-[1rem] text-gray-600 leading-[1.5rem] mb-[60px]">
        in 2–3 days for the status.
      </p>

      <!-- Spacer to push button to bottom -->
      <div class="flex-1"></div>

      <!-- Back to MyGiving Button -->
      <button
        @click="backToMyGiving"
        class="w-full p-[16px] bg-gray-800 rounded-[12px] text-[1rem] font-[600] text-white"
      >
        Back to MyGiving
      </button>
    </div>
  </my-giving-layout>
</template>

<script>
import axios from 'axios';
import MyGivingLayout from '@/components/MyGivingLayout.vue';

export default {
  name: 'BoRedirection',
  async mounted() {
    // Extract query parameters and make API call
    await this.processBoRedirection();
  },
  methods: {
    async processBoRedirection() {
      try {
        // Extract query parameters from the URL
        const urlParams = new URLSearchParams(window.location.search);

        // Forward every parameter DBS sent, not a subset.
        //
        // The eGIRO spec (v4.1.5 §4.2) signs the whole query string and makes
        // `signature`, `nonce` and `timestamp` mandatory; the API rebuilds that
        // string and verifies it. Dropping a field here — or adding one DBS did
        // not send — makes the rebuilt payload differ from the signed one and
        // the redirect is rejected. `error` (User_Rejected / Incomplete_Flow)
        // is how the API knows not to record a mandate the member declined.
        const body = {};
        for (const [key, value] of urlParams.entries()) {
          body[key] = value;
        }

        console.log('BO Redirection parameters:', body);

        // Make POST request to backend
        const response = await axios.post(
          `${process.env.VUE_APP_GIVING_API_V2_URL}/e-giro/bo-redirection`,
          body,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
          },
        );

        console.log('BO Redirection API response:', response.data);

        // TODO: Handle different status responses if needed
        // For now, we just show the success page regardless
      } catch (error) {
        console.error('Error processing BO redirection:', error);

        // TODO: Consider showing error state or still showing success
        // For now, we'll still show the success page but log the error
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to process bank response.';

        console.error('BO Redirection API error:', errorMessage);
        // Could show a toast notification or update UI state here
      }
    },
    backToMyGiving() {
      this.$router.replace('/my-giving');
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Inter';
}
</style>
